import { FieldLabels } from '../../../../Model/CoachInfo';

const texts = {
  save: 'Save',
  savedSuccessfully: 'Coach Information Saved Successfully',
  errorSavingInfo: 'Error saving coach information',
  title: 'Coach Information',
  [FieldLabels.CoachName]: {
    label: 'Coach Name',
    placeholder: 'Enter coach name',
  },
  [FieldLabels.CoachNamePronunciation]: {
    label: 'Coach Name Pronunciation',
    placeholder: 'Enter pronunciation',
  },
  [FieldLabels.CoachLocation]: {
    label: 'Coach Location',
    placeholder: 'Enter location',
  },
  [FieldLabels.SpecificRequirements]: {
    label: 'Specific requirements to mention on calls',
    placeholder: 'Enter specific requirements',
  },
  [FieldLabels.TrainingProgramme]: {
    label: 'Training Programme',
    placeholder: 'Enter training programme',
  },
  [FieldLabels.NutritionPlan]: {
    label: 'Nutrition Plan',
    placeholder: 'Enter nutrition plan',
  },
  [FieldLabels.PointOfContact]: {
    label: 'Point of contact - coach/client',
    placeholder: 'Enter point of contact',
  },
  [FieldLabels.ResponseTime]: {
    label: 'Response time in chat',
    placeholder: 'Enter response time',
  },
  [FieldLabels.ValuesAndBeliefs]: {
    label: 'Values and beliefs',
    placeholder: 'Enter values and beliefs',
  },
  [FieldLabels.EducationAndQualification]: {
    label: 'Education and qualification',
    placeholder: 'Enter education and qualification',
  },
  [FieldLabels.ClientRequirementsAccepts]: {
    label: 'Client requirements - Accepts',
    placeholder: 'Enter client requirements that are accepted',
  },
  [FieldLabels.ClientRequirementsDoesNotAccept]: {
    label: 'Client requirements - Does not accept',
    placeholder: 'Enter client requirements that are not accepted',
  },
  [FieldLabels.Personas]: {
    label: 'Personas',
    placeholder: 'Enter personas',
  },
  [FieldLabels.ContactEmail]: {
    label: 'Contact email - inbound to coach',
    placeholder: 'Enter contact email',
  },
  [FieldLabels.WebsiteURL]: {
    label: 'Website URL',
    placeholder: 'Enter website URL',
  },
  [FieldLabels.Instagram]: {
    label: 'Instagram',
    placeholder: 'Enter Instagram handle',
  },
  [FieldLabels.Tiktok]: {
    label: 'Tiktok',
    placeholder: 'Enter TikTok handle',
  },
};

export default texts;
